import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./store";
import "bootstrap";
import { Icon } from "./fontAwesomeConfig";

createApp(App).use(store).use(router).component("icon", Icon).mount("#app");
